import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class UserAuthIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M8,15a7,7,0,1,1,7-7A7,7,0,0,1,8,15Zm2.26-5c-1-.4-1.38-.73-1.38-1.45,0-.43.32-.29.46-1.09.06-.32.34,0,.4-.75,0-.3-.15-.38-.15-.38s.07-.44.1-.78A1.49,1.49,0,0,0,8,4,1.49,1.49,0,0,0,6.31,5.52c0,.34.11.78.11.78s-.16.08-.16.38c.06.75.34.42.4.75.14.79.46.65.46,1.09,0,.72-.33,1.06-1.38,1.46S4,10.78,4,11.06V12h8v-.94C12,10.78,11.32,10.37,10.26,10Z"/>
  ]
  getViewBox = () => '0 0 16 16'
}


